import { render, staticRenderFns } from "./transaction-data.vue?vue&type=template&id=4eab9d81&scoped=true&"
import script from "./transaction-data.vue?vue&type=script&lang=js&"
export * from "./transaction-data.vue?vue&type=script&lang=js&"
import style0 from "./transaction-data.vue?vue&type=style&index=0&id=4eab9d81&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eab9d81",
  null
  
)

export default component.exports